import React, { useState, useEffect } from 'react';
import { Pie, Line, Bar, HorizontalBar,} from 'react-chartjs-2';

import { GMMain } from './GraphMaster.style';
import CustomizedTables from '../Table/Table';
import TableTrendSexo from '../Table/TableTrendSexo';
import TableTrendEdad from '../Table/TableTrendEdad';
import TableTrendRegion from '../Table/TableTrendRegion';
import TableTrendRangoIngreso from '../Table/TableTrendRangoIngreso';

import ReactWordcloud from 'react-wordcloud';

import Chart from "react-google-charts";

const GraphMaster = (props) => {
  const [ state, setState ] = useState([])

  
  let { data, special } = props;
  
  
  let checkGraphKind = (type) => {
    let labelArray = [];
    let dataArray = [];
    let dataArray2 = [];
    let dataArray3 = [];
    let price_new = null;
    let price_list = [];
    let mapData = null;
    let Conteo = null;
    let mapInfo = {};
    let word = {}
    let data = null; 
    let options = null; 
    let limit = 8
    if(type){
    switch(type.name) {
      case 'Conteo_Sexo':
        type.data.map(element => {
          labelArray.push(element.Sexo)
          dataArray.push(element.Freq)
          return;
        })
        // for (const x in type.data){
        //   labelArray.push(x)
        //   dataArray.push(type.data[x].Freq)
        // }
        data = {
          labels: labelArray,
          datasets: [{
            data: dataArray,
            backgroundColor: [
              '#3DBAB3',
              '#9EDCD9'
            ],
            hoverBackgroundColor: [
              '#3DBAB3',
              '#9EDCD9'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          fullWidth: true,
          legend: {
            display: false,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Sexo'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Proporción, conteo'
              }
            }]
          }
        }
        return <Bar data={data} options={options}/>
      case 'Conteo_GrupoEdad':
        type.data.map(element => {
          labelArray.push(element.GrupoEdad)
          dataArray.push(element.Freq)
          return;
        })

        data = {
          labels: [labelArray[3], labelArray[0], labelArray[1], labelArray[2]],
          datasets: [{
            data: [dataArray[3], dataArray[0], dataArray[1], dataArray[2]],
            backgroundColor: [
              '#D4D3D7',
              '#7D7A87',
              '#514E5F',
              '#3B384B'
            ],
            hoverBackgroundColor: [
              '#D4D3D7',
              '#7D7A87',
              '#514E5F',
              '#3B384B'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          fullWidth: true,
          legend: {
            display: false,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Edad'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Proporción, conteo'
              }
            }]
          }
        }
        return <Bar data={data} options={options}/>
      case 'Conteo_Rango_Ingreso':
        
        for (let x in type.data){
          labelArray.push(x)
          dataArray.push(type.data[x].Freq)
        }
        data = {
          labels: [...labelArray],
          datasets: [{
            label: "Proporción Rango-Ingreso",
            data: [...dataArray],
            backgroundColor: [
              '#C72544',
              '#DF668F',
              '#F4CCDA'
            ],
            hoverBackgroundColor: [
              '#C72544',
              '#DF668F',
              '#F4CCDA'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          responsive: true,
          fullWidth: true,
          legend: {
            display: true,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Nivel de ingreso'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Proporción, conteo'
              }
            }]
          }
        }
        return <Bar data={data} options={options}/>
      case 'SentimientoPromedioDiario':
        type.data.map(element => {
          labelArray.push(element.Date)
          dataArray.push(element.Sentiment.toFixed(4))
          return;
        })
        // for (let x in type.data){
        //   labelArray.push(x)
        //   dataArray.push(type.data[x])
        // }
        data = {
          fill: true,
          legend: "Sentimiento promedio",
          display: true,
          labels: labelArray.sort(function (a, b) {
            if (a < b) {
                return -1;
            }
            if (b > a) {
                return 1;
            }
            return 0;
        }),
          defaultFontSize: 2,
          responsive: true,
          datasets: [{
            label: "Percepción del usuario",
            data: dataArray,
            backgroundColor: [
              '#F2D7E1',
              // '#DF668F',
              // '#F4CCDA'
            ],
            hoverBackgroundColor: [
              '#F2D7E1',
              // '#DF668F',
              // '#F4CCDA'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          responsive: true,
          fullWidth: true,
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Fecha'
              }
            }],
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Sentimiento promedio'
              }
            }]
          }
        }
        return <Line data={data}  options={options}/>
      case 'SentimientoProm_Sexo':
        for (let x in type.data){
          labelArray.push(x)
          dataArray.push(type.data[x].Sentiment.toFixed(4))
        }
        data = {
          labels: [...labelArray],
          datasets: [
          //   {
          //   label: false,
          //   data: [...dataArray],
          //   backgroundColor: [
          //     '#3DBAB3',
          //     '#9EDCD9'
          //   ],
          //   hoverBackgroundColor: [
          //     '#3DBAB3',
          //     '#9EDCD9'
          //   ]
          // }
          {
            // label: 'F',
            backgroundColor: '#3DBAB3',
            // borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            // stack: '1',
            // hoverBackgroundColor: '#DBF2F2',
            // hoverBorderColor: '#DBF2F2',
            data: [...dataArray]
            // [dataArray[3].neg, dataArray[1].neg, dataArray[0].neg, dataArray[2].neg]
          },
          // {
          //   label: 'M',
          //   backgroundColor: '#9EDCD9',
          //   borderColor: 'rgba(45,149,102,1)',
          //   // borderWidth: 1,
          //   // stack: '2',
          //   // hoverBackgroundColor: '#FFE0E6',
          //   // hoverBorderColor: '#FFE0E6',
          //   // data: [dataArray[3].neu, dataArray[1].neu, dataArray[0].neu, dataArray[2].neu],
          //   data: [,dataArray[1]]
          // },
        ]
        };
        // options = {
        //   legend: {
        //     display: false
        // },
        //   display: true,
        //   position: "top",
        //   fullWidth: true,
        //   reverse: false,
        //   labels: {
        //     fontColor: 'rgb(255, 99, 132)'
        //   },
        //   maintainAspectRatio: false
        // }
        options = {
          maintainAspectRatio: false,
          responsive: true,
          fullwidth: true,
          legend: {
            display: false,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Sexo'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Sentimiento promedio'
              }
            }]
          }
        }
        return <Bar data={data} options={options}/>
      case 'ProporcionEmociones':
          for (let x in type.data){ 
            if(x === "neg"){
              labelArray.push("Negativo")
            } else if(x === "neu"){
              labelArray.push("Neutral")
            } else {
              labelArray.push("Positivo")
            }
            // labelArray.push(x)
            dataArray.push(type.data[x].toFixed(4))
          }
        data = {
          labels: labelArray,
          datasets: [{
            data: dataArray,
            backgroundColor: [
              '#C72544',
              '#DF668F',
              '#E999B5'
            ],
            hoverBackgroundColor: [
              '#C72544',
              '#DF668F',
              '#E999B5'
            ]
          }]
        };
        // options = {
        //   display: true,
        //   position: "top",
        //   fullWidth: true,
        //   reverse: false,
        //   labels: {
        //     fontColor: 'rgb(255, 99, 132)'
        //   },
        //   maintainAspectRatio: false
        // }
        options = {
          maintainAspectRatio: false,
          responsive: true,
          fullwidth: true,
          legend: {
            display:false,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Percepción'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Proporción del total'
              }
            }]
          }
        }
        return <Bar data={data} options={options}/>
        case 'SentimientoProm_Sexo2':
        for (let x in type.data){ 
          labelArray.push(x)
          dataArray.push(type.data[x].Conteo)
        }
        data = {
          labels: labelArray,
          datasets: [{
            data: dataArray,
            backgroundColor: [
              '#3DBAB3',
              '#9EDCD9'
            ],
            hoverBackgroundColor: [
              '#3DBAB3',
              '#9EDCD9'
            ]
          }]
        };
        options = {
          display: true,
          position: "top",
          fullWidth: true,
          reverse: false,
          labels: {
            fontColor: 'rgb(255, 99, 132)'
          },
          maintainAspectRatio: false
        }
        return <Bar data={data} options={options}/>
      case 'EmocionesPromedioDiario':
        for (let x in type.data){
          labelArray.push(x)
          dataArray.push(type.data[x].neg,)
          dataArray2.push(type.data[x].pos,)
          dataArray3.push(type.data[x].neu)
        }
        data = {
          fill: true,
          legend: "Emociones promedio",
          display: true,
          labels: labelArray,
          defaultFontSize: 2,
          responsive: true,
          datasets: [
            {
              label: "Positivo",
              data: dataArray2,
              backgroundColor: [
                '#CCF1F0'
              ],
              hoverBackgroundColor: [
                '#CCF1F0'
              ]
            },
            {
              label: "Negativo",
              data: dataArray,
              backgroundColor: [
                '#F2D7E1'
              ],
              hoverBackgroundColor: [
                '#F2D7E1'
              ]
            },
            {
              label: "Neutral",
              data: dataArray3,
              backgroundColor: [
                '#BDBCC3'
              ],
              hoverBackgroundColor: [
                '#BDBCC3'
              ]
            }
          ]
        };
        options = {
          maintainAspectRatio: false,
          legend: {
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Fecha'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Proporción del total'
              }
            }]
          }
        }
        return <Line data={data} options={options}/>

      case 'Precios_Stats':
        // let i = 0;
        // let allPices = []
        for (let x in type.data){
          // i++
          // allPrices.push()
          if(type.data[x].Price_new != null){
            price_list.push(type.data[x].Price_new)
          }
          if(type.data[x].Sentiment !== null){
            labelArray.push(x)
            dataArray.push(type.data[x].Sentiment)
            dataArray2.push(price_list[price_list.length - 1])
          }
        }

        data = {
          labels: labelArray,
          datasets: [{
            fill: false,
            label: 'Sentimiento',
            yAxisID: 'Sentimiento',
            // lineTension: 0.1,
            // backgroundColor: 'rgba(75,192,192)',
            borderColor: '#3DBAB3',
            // borderCapStyle: 'butt',
            // borderDash: [],
            // borderDashOffset: 1.0,
            data: dataArray,
            hoverBackgroundColor: [
              '#3DBAB3',
              // '#DF668F',
              // '#F4CCDA'
            ]
          },
          {
            fill: false,
            label: 'Precio',
            yAxisID: 'Precio',
            // lineTension: 0.1,
            // backgroundColor: 'rgba(75,192,192)',
            borderColor: '#C72544',
            // borderCapStyle: 'butt',
            // borderDash: [],
            // borderDashOffset: 1.0,
            data: dataArray2,
            hoverBackgroundColor: [
              // '#3DBAB3',
              // '#DF668F',
              '#F4CCDA'
            ]
          }]
        }
        options = {
          scales: {
            yAxes: [{
              id: 'Sentimiento',
              type: 'linear',
              position: 'left',
              ticks: {
                max: Math.max.apply(Math, dataArray),
                min: Math.min.apply(Math, dataArray)
              }
            }, {
              id: 'Precio',
              type: 'linear',
              position: 'right',
              ticks: {
                max: Math.max.apply(Math, price_list),
                min: Math.min.apply(Math, price_list)
                
              }
            }]
          }
        }
        // { maintainAspectRatio: false }
        return <Line data={data} options={options}/>
      case 'Keepa':
        for (let x in type.data){
          labelArray.push(x)
          dataArray.push(type.data[x].Price_new)
        }
        data = {
          labels: labelArray,
          datasets: [{
            fill: false,
            steppedLine: true,
            label: 'Precio',
            // lineTension: 0.1,
            // backgroundColor: 'rgba(75,192,192)',
            borderColor: 'rgba(75,192,192,1)',
            // borderCapStyle: 'butt',
            // borderDash: [],
            // borderDashOffset: 1.0,
            data: dataArray,
            hoverBackgroundColor: [
              '#3DBAB3',
              // '#DF668F',
              // '#F4CCDA'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          responsive: true,
          fullwidth: true,
          legend: {
            display:true,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Fecha'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Precio promedio'
              }
            }]
          }
        }
        return <Line data={data} options={options}/>
      
      case 'Precios_Stats_Conteo':
        
        // let allPices = []
        for (let x in type.data){
          
          // allPrices.push()
          if(type.data[x].Price_new != null){
            price_list.push(type.data[x].Price_new)
          }
          if(type.data[x].Sentiment !== null){
            labelArray.push(x)
            dataArray.push(type.data[x].Conteo)
            dataArray2.push(price_list[price_list.length - 1])
          }
        }

        data = {
          labels: labelArray,
          datasets: [{
            fill: false,
            label: 'Conteo',
            yAxisID: 'Conteo',
            // lineTension: 0.1,
            // backgroundColor: 'rgba(75,192,192)',
            borderColor: '#3DBAB3',
            // borderCapStyle: 'butt',
            // borderDash: [],
            // borderDashOffset: 1.0,
            data: dataArray,
            hoverBackgroundColor: [
              '#3DBAB3',
              // '#DF668F',
              // '#F4CCDA'
            ]
          },
          {
            fill: false,
            label: 'Precio',
            yAxisID: 'Precio',
            // lineTension: 0.1,
            // backgroundColor: 'rgba(75,192,192)',
            borderColor: '#C72544',
            // borderCapStyle: 'butt',
            // borderDash: [],
            // borderDashOffset: 1.0,
            data: dataArray2,
            hoverBackgroundColor: [
              // '#3DBAB3',
              // '#DF668F',
              '#F4CCDA'
            ]
          }]
        }
        options = {
          scales: {
            yAxes: [{
              id: 'Conteo',
              type: 'linear',
              position: 'left',
              ticks: {
                max: Math.max.apply(Math, dataArray),
                min: Math.min.apply(Math, dataArray),
                fontSize: 8
              }
            }, {
              id: 'Precio',
              type: 'linear',
              position: 'right',
              ticks: {
                max: Math.max.apply(Math, price_list),
                min: Math.min.apply(Math, price_list),
                fontSize: 8
                
              }
            }]
          },
          // legend: {
          //   labels: {
          //       fontSize: 7,
          //       fontColor: 'black'
          //   }
          // }
        }
        // { maintainAspectRatio: false }
        return <Line data={data} options={options}/>
      case 'TrendGeneral':
        // if(props.wordMapData){
        //   return <ReactWordcloud words={props.wordMapData} />  
        // } return;
        options = {
          colors: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b'],
          enableTooltip: true,
          deterministic: false,
          fontFamily: 'impact',
          fontSizes: [5, 30],
          fontStyle: 'normal',
          fontWeight: 'normal',
          padding: 1,
          rotations: 3,
          rotationAngles: [0, 90],
          scale: 'sqrt',
          spiral: 'archimedean',
          transitionDuration: 1000,
          maintainAspectRatio: true
        };
        type.data.map(element => {
          if(element.n === 1 || element.n === 2) {
            word = {
              text: element.ngram,
              value: element.freq
            }
            labelArray.push(word)

          }
        })
        return <ReactWordcloud words={labelArray} options={options} height={250}/>
        // TABLES GRAPHS
      case 'Elasticidad': 
        return <CustomizedTables data={type.data} />
      case 'Trend_Sexo':
        return <TableTrendSexo data={type.data} />
      case 'Trend_GrupoEdad':
        return <TableTrendEdad data={type.data} />
      case 'Trend_Region':
        return <TableTrendRegion data={type.data} />
      case 'Trend_Rango_Ingreso':
        return <TableTrendRangoIngreso data={type.data} />
        
      case 'Conteo_Region':
        let getMapData = () => {
          // return new Promise((resolve, reject) => {
              let noreste= type.data.find(element => element.Region === "Noreste")
              let occidente= type.data.find(element => element.Region === "Occidente")
              let centro= type.data.find(element => element.Region === "Centro")
              let noroeste= type.data.find(element => element.Region === "Noroeste")
              let sureste= type.data.find(element => element.Region === "SurEste")
            // resolve((() => {
               mapInfo = {
                noreste: noreste ? noreste.Freq : 0,
                occidente: occidente ? occidente.Freq : 0,
                centro: centro ? centro.Freq : 0,
                noroeste: noroeste ? noroeste.Freq : 0,
                sureste: sureste ? sureste.Freq : 0,
              }

              return mapInfo
            // })())
          // })
        }
        getMapData()
        // .then(mapInfo => {
           mapData = [
            ['State', 'Sentiment'],
            ['Baja California', mapInfo.noroeste],
            ['Sonora',  mapInfo.noroeste],
            ['Chihuahua',  mapInfo.noroeste],
            ['Coahuila', mapInfo.noreste],
            ['Nuevo León', mapInfo.noreste],
            ['Tamaulipas', mapInfo.noreste],
            ['Sinaloa',  mapInfo.noroeste],
            ['Nayarit', mapInfo.occidente],
            ['Durango', mapInfo.noreste],
            ['Zacatecas', mapInfo.occidente],
            ['Jalisco', mapInfo.occidente],
            ['Colima', mapInfo.occidente],
            ['Tlaxcala', mapInfo.centro],
            ['Aguascalientes', mapInfo.occidente],
            ['Zacatecas', mapInfo.occidente],
            ['San Luis Potosí', mapInfo.noreste],
            ['Puebla', mapInfo.centro],
            ['Guanajuato', mapInfo.occidente],
            ['Querétaro', mapInfo.occidente],
            ['Hidalgo', mapInfo.centro],
            ['Morelos', mapInfo.centro],
            ['Estado de México', mapInfo.centro],
            ['Distrito Federal', mapInfo.centro],
            ['Baja California Sur', mapInfo.noroeste],
            ['Michoacán', mapInfo.occidente],
            ['Guerrero', mapInfo.sureste],
            ['Oaxaca', mapInfo.sureste],
            ['Veracruz', mapInfo.sureste],
            ['Tabasco', mapInfo.sureste],
            ['Campeche',  mapInfo.sureste],
            ['Chiapas', mapInfo.sureste],
            ['Quintana Roo', mapInfo.sureste],
            ['Yucatán', mapInfo.sureste],
          ]
        // })
        return !mapData ? <div>Loading...</div> :
         <Chart
          width={'300px'}
          height={'180px'}
          chartType="GeoChart"
          // data={{...mapData}}
          data={[...mapData]}
          options={{
            fill:'#FBFEFE',
            region: 'MX', // Mexico
            resolution: 'provinces',
            colorAxis: {
              //     	minValue=100,
              //     maxValue=400,
              values: [0, 1, 30, 40, 200],
              colors: ['#EEEEEE', '#EFB2C7', '#E999B5', '#DF668F', '#DF3870']
            },
            backgroundColor: '#f4f2f2',
            datalessRegionColor: '#eeeeee',
            defaultColor: '#f5f5f5',
            // sizeAxis: { minValue: 0, maxValue: 100 },
            // region: '155', // Western Europe
            // displayMode: 'markers',
            // colorAxis: { colors: ['#e7711c', '#4374e0'] }, // orange to blue
          }}
          // Note: you will need to get a mapsApiKey for your project.
          // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
          mapsApiKey="YOUR_KEY_HERE"
          rootProps={{ 'data-testid': '3' }}
        />
        break;
      // case '':
      //   break;
      // case '':
      //   break;
      default:
        break;
  };
}else if(special === "TrendGeneral_Bars"){
        let limit = 8
        data.data.map(element => {
          while(limit > 0){
            if(element.n === 1 || element.n === 2) {
              labelArray.push(element.ngram)
              dataArray.push(element.freq)
              return;
            }
            limit--
          }
        })
        data = {
          labels: labelArray,
          datasets: [{
            data: dataArray,
            backgroundColor: [
              '#C72544',
              '#d63e59',
              '#e0506b',
              '#db647a',
              '#db7a8c',
              '#d88493'
            ],
            hoverBackgroundColor: [
              '#C72544',
              '#d63e59',
              '#2ca02c',
              '#db647a',
              '#db7a8c',
              '#d88493'
            ]
          }]
        };
        // return <HorizontalBar data={data} options={{ maintainAspectRatio: false }}/> 
}else {
  return <div>No hay información</div>
}

  }
  return (
    <GMMain>
      { checkGraphKind(data) }
    </GMMain>
  );
}

export default GraphMaster;
